import Vue from 'vue'

import VueAkeyboard from 'vue-akeyboard'
Vue.use(VueAkeyboard)
